module.exports = __webpack_public_path__ + "img/sia_619m_list.4a46e814.jpg";